import {Component} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {PO_ITEM_LIST_DELIVERIES, PO_LIST_DELIVERIES} from '../../queries-workflow';
import {Query as WorkflowQuery} from '../../types-workflow';
import {ActivatedRoute} from '@angular/router';
import {HttpHeaders} from '@angular/common/http';
import {AutoLogoutComponent} from '../../components/auto-logout/auto-logout.component';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Location} from '@angular/common';

type ReportState = 'loading' | 'no-data' | 'ready' | 'error';

@Component({
  selector: 'app-display-delivery-report',
  imports: [
    AutoLogoutComponent
  ],
  templateUrl: './display-delivery-report.component.html',
  styleUrl: './display-delivery-report.component.scss'
})
export class DisplayDeliveryReportComponent {
  state: ReportState = 'loading';
  reportHtml: SafeHtml = null;
  errorMessage: string = null;

  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private location: Location
  ) {
    this.loadReport();
  }

  goBack() {
    this.location.back();
  }

  private loadReport() {
    let query;
    if (!this.route.snapshot.params['po_item_id']) {
      query = PO_LIST_DELIVERIES(this.route.snapshot.params['organization_id']);
    } else {
      query = PO_ITEM_LIST_DELIVERIES(this.route.snapshot.params['organization_id']);
    }

    this.apollo.use('workflow').query<WorkflowQuery>({
      query: query,
      // Not the cache: it keys list_POs on ContextService.organizationId(), which lags the route until
      // NavigationEnd, and this runs from the constructor. Coming from a PO in another organization, the
      // report was answered from that organization's entry, with no request (VTK-3591).
      fetchPolicy: 'no-cache',
      context: {
        headers: new HttpHeaders({
          'X-Castlabs-Organization': this.route.snapshot.params['organization_id'],
        })
      },
      variables: {
        'po_name': this.route.snapshot.params['po_name'],
        'po_item_id': this.route.snapshot.params['po_item_id'],
        'format': 'HTML'
      }
    }).subscribe({
      next: res => {
        let htmlInJson: string | null = null;
        if (!res.data?.list_POs?.pos) return;
        for (const po of res.data.list_POs.pos) {
          // For PO-level reports (finalize_reports)
          if (po.finalize_reports?.length > 0) {
            htmlInJson = po.finalize_reports[0] as unknown as string;
            break;
          }
          // For POItem-level reports (publish_reports)
          if (po.poitems) {
            for (const poitem of po.poitems) {
              if (poitem.publish_reports?.length > 0) {
                htmlInJson = poitem.publish_reports[0];
                break;
              }
            }
          }
          if (htmlInJson) break;
        }

        if (!htmlInJson) {
          this.state = 'no-data';
          return;
        }

        const html = JSON.parse(htmlInJson);

        this.reportHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        this.state = 'ready';
      },
      error: err => {
        this.state = 'error';
        this.errorMessage = err.message || 'Failed to load report';
      }
    });
  }

  printPage() {
    window.print();
  }
}
